import styled, { css } from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { centerAbsolute } from '@/styles/helpers';

export const LogoLinkBox = styled(CustomLink)<{
  $hasCenterAbsolute: boolean;
  $isLeftAlignedOnDesktop: boolean;
}>`
  display: flex;

  ${({ $hasCenterAbsolute }) =>
    $hasCenterAbsolute &&
    css`
      @media (max-width: 949px) {
        ${centerAbsolute()}
      }
    `}

  @media (min-width: 950px) {
    margin-right: ${({ $isLeftAlignedOnDesktop }) =>
      $isLeftAlignedOnDesktop ? 'auto' : '31px'};
  }
`;
